import { createContext } from 'utilsTS/react';
import { TIER, DEFAULT_TIER, TIER_WIDTH } from './constants';

export interface ContainerQueryContextTypes {
    width?: number;
    isMatchingTier: (tier: TIER) => boolean;
    matchingTier: TIER;
    matchingTiers: TIER[];
    defaultTier: TIER;
    tierWidths: Record<TIER, number>;
}

export const ContainerQueryContext = createContext<ContainerQueryContextTypes>('ContainerQuery', {
    isMatchingTier: () => false,
    matchingTier: DEFAULT_TIER,
    matchingTiers: [],
    defaultTier: DEFAULT_TIER,
    tierWidths: TIER_WIDTH,
});
